// Import the Button component from this folder and send it down to ./components/index.js
import Button from './Button';

export default Button;